import { type ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";

import {
  Banner,
  BannerList,
} from "~/components/design-system/Banner/Banner.js";
import { Button } from "~/components/design-system/Button/Button.js";
import { FormTitle } from "~/components/design-system/FormTitle/FormTitle.js";
import { PopupDialog } from "~/components/design-system/PopupDialog/PopupDialog.js";

export function ConfirmationModal({
  title = "Please Confirm Your Action",
  extraWarning,
  message,
  confirmFn,
  closeFn,
  disabledConfirm,
}: {
  title?: string;
  extraWarning?: string;
  message: ReactNode;
  confirmFn: () => void;
  closeFn: () => void;
  disabledConfirm?: boolean;
}) {
  return (
    <PopupDialog open={true} onClose={closeFn} testId="confirmation-dialog">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "1em",
        }}
      >
        <IconButton
          aria-label={"Close"}
          onClick={closeFn}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <FormTitle
          useReducedTopPadding={true}
          hasContainerMarginBottom={false}
          showBorder={false}
          isAlignedLeft={false}
          titleText={title}
        />
        {extraWarning && (
          <Box
            sx={{
              marginLeft: "2em",
              marginRight: "2em",
              marginTop: "1em",
              marginBottom: "1em",
            }}
          >
            <Banner title={extraWarning} bannerType={BannerList.ERROR} />
          </Box>
        )}
        <Box sx={{ marginLeft: "2em", marginRight: "2em" }}>
          {typeof message === "string" ? (
            <Banner title={message} bannerType={BannerList.WARNING} />
          ) : (
            message
          )}
        </Box>
        <Box
          sx={{
            marginTop: "2em",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            label="Close"
            testId="close-button"
            onClick={closeFn}
            color={"inherit"}
          />
          <Button
            label="Confirm"
            testId="confirm-button"
            onClick={confirmFn}
            disabled={disabledConfirm}
          />
        </Box>
      </Box>
    </PopupDialog>
  );
}
